export default "__VITE_PUBLIC_ASSET__fe276728__"